var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 3C12.3882 3 14 4.61177 14 6.6C14 7.02103 13.9635 7.42076 13.8963 7.79995H11.0974L10.3532 6.0636C10.2587 5.84299 10.0417 5.69995 9.80173 5.69995C9.56172 5.69995 9.34479 5.84299 9.25025 6.0636L8.00173 8.9768L7.65322 8.1636C7.55867 7.94299 7.34175 7.79995 7.10173 7.79995H2.10547C2.18095 8.22545 2.29519 8.6251 2.44016 8.99995H6.70609L7.45025 10.7363C7.54479 10.9569 7.76172 11.1 8.00173 11.1C8.24175 11.1 8.45867 10.9569 8.55322 10.7363L9.80173 7.82311L10.1502 8.6363C10.2448 8.85691 10.4617 8.99995 10.7017 8.99995H13.5616C12.4823 11.7906 9.70001 13.2076 8.53039 13.6952C8.18872 13.8377 7.81128 13.8377 7.46961 13.6952C6.00287 13.0837 2 11.0106 2 6.6C2 4.61177 3.61177 3 5.6 3C6.52203 3 7.36309 3.34662 8 3.91667C8.63691 3.34662 9.47797 3 10.4 3ZM13.5616 8.99995H13.5633C13.7083 8.6251 13.8225 8.22545 13.898 7.79995H13.8963C13.8208 8.22545 13.7065 8.6251 13.5616 8.99995Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareTeam);
export default __webpack_public_path__ + "static/media/care-team.4ea709ab83719fc5fe168662b426b58f.svg";
export { ForwardRef as ReactComponent };